export default __webpack_public_path__ + "static/media/the-key-to-encryption.0087640f.jpg";